export default "__VITE_ASSET__DIzadHdD__"